import { ConnectionUserWithConnectionAccepted } from "@lib/store";
import { useTranslation } from "react-i18next";
import { ListHeader } from "../ListHeader";
import { Card } from "@atoms";
import { AddConnectionsCard } from "@organisms";
import { cn } from "@utils";
import { useModal } from "@hooks";
import { ConnectionSectionItem } from "./ConnectionSectionItem";
import { SectionEmptyCard } from "../SectionEmptyCard";

export const ConnectionsSection = ({
  acceptedConnections,
  className,
}: {
  acceptedConnections: ConnectionUserWithConnectionAccepted[];
  className?: string;
}) => {
  const { t } = useTranslation();
  const { addPages, openModal } = useModal();

  const handleOpenAddConnections = () => {
    addPages([<AddConnectionsCard />]);
    openModal();
  };

  return (
    <Card className={cn("flex flex-col py-8 gap-6 self-start", className)}>
      <ListHeader
        title={t("connection:ConnectedColleagues", { count: acceptedConnections.length })}
        className="px-4 sm:px-6 md:px-8"
        action={handleOpenAddConnections}
      />

      {!!acceptedConnections.length ? (
        <div className="grid divide-y">
          {acceptedConnections.map(user => (
            <ConnectionSectionItem
              user={user}
              key={user.id}
            />
          ))}
        </div>
      ) : (
        <SectionEmptyCard
          description={t("connection:ConnectionsEmptyState")}
          button={{
            label: t("connection:Connect"),
            onClick: handleOpenAddConnections,
          }}
        />
      )}
    </Card>
  );
};
